import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { API, formatErr } from "@/lib/site";
import { LogoMark } from "@/components/site/Logo";

const field = "w-full bg-transparent border-b border-[#121518]/20 focus:border-[#0F4C3A] focus:outline-none py-3";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("lrsp_token", data.token);
      nav("/admin/painel");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-8 sm:p-12 shadow-[0_30px_80px_-30px_rgba(18,21,24,0.2)]" data-testid="admin-login-form">
        <LogoMark className="w-12 h-12" />
        <h1 className="font-serif-d text-4xl mt-6">Área administrativa</h1>
        <p className="text-sm text-[#525860] mt-2">Acesso restrito aos pedidos de orçamento.</p>
        <div className="mt-8 space-y-6">
          <input data-testid="admin-input-email" type="email" required placeholder="E-mail" className={field} value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-input-password" type="password" required placeholder="Senha" className={field} value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-700">{error}</p>}
        <button data-testid="admin-login-submit" disabled={loading}
          className="mt-8 w-full rounded-full bg-[#0F4C3A] text-[#FAF8F5] py-4 flex items-center justify-center gap-2 hover:bg-[#121518] transition-colors disabled:opacity-60">
          {loading && <Loader2 size={18} className="animate-spin" />} Entrar
        </button>
        <Link to="/" className="block text-center text-sm text-[#525860] mt-6 hover:text-[#121518]" data-testid="admin-back-home">← Voltar ao site</Link>
      </form>
    </div>
  );
}
